import Phaser from 'phaser';
import { GAME_H, GAME_W } from './core/config';
import { GameContext } from './core/context';
import { installDebugApi } from './core/debug';
import { applyZoom } from './core/scale';
import { bus, Events } from './core/events';
import { BootScene } from './core/scenes/BootScene';
import { PreloadScene } from './core/scenes/PreloadScene';
import { TitleScene } from './core/scenes/TitleScene';
import { UIScene } from './core/scenes/UIScene';
import { LoadingScene } from './core/scenes/LoadingScene';
import { PrologueScene } from './content/prologue/PrologueScene';
import { GreenHarborScene } from './content/green-harbor/GreenHarborScene';
import { TurtleInnScene } from './content/turtle-inn/TurtleInnScene';
import { ChapterEndScene } from './content/ChapterEndScene';
import { ShowcaseScene } from './content/ShowcaseScene';
import { ensureAudioIfAvailable, installAutosaveIfAvailable, registerAllShowcases } from './core/wiring';

function showFatal(message: string): void {
  if (document.querySelector('.nantian-error')) return;
  const el = document.createElement('div');
  el.className = 'nantian-error';
  el.innerHTML = `<div>出错了：${message}</div><button type="button">重新载入</button>`;
  el.querySelector('button')?.addEventListener('click', () => location.reload());
  document.body.appendChild(el);
}

const url = GameContext.parseUrl(location.search);

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-root',
  width: GAME_W,
  height: GAME_H,
  backgroundColor: '#0b0f14',
  pixelArt: true,
  roundPixels: true,
  antialias: false,
  scale: { mode: Phaser.Scale.NONE, autoCenter: Phaser.Scale.CENTER_BOTH, width: GAME_W, height: GAME_H },
  audio: { disableWebAudio: false },
  input: { keyboard: true, mouse: true, touch: true, gamepad: false },
  fps: { target: 60, forceSetTimeOut: false },
  scene: [BootScene, PreloadScene, UIScene, LoadingScene, TitleScene, PrologueScene, GreenHarborScene, TurtleInnScene, ChapterEndScene, ShowcaseScene],
});

registerAllShowcases();
const ctx = new GameContext(game, url);
game.registry.set('ctx', ctx);
installDebugApi(game, ctx);
installAutosaveIfAvailable(ctx);
ensureAudioIfAvailable(game);

const rezoom = () => applyZoom(game, ctx.settings.zoom);
window.addEventListener('resize', rezoom);
bus.onTyped(Events.SETTINGS_CHANGE, () => rezoom());
game.events.once(Phaser.Core.Events.READY, rezoom);

window.addEventListener('error', (e) => { if (import.meta.env.PROD) showFatal(String(e.message)); });
window.addEventListener('unhandledrejection', (e) => { if (import.meta.env.PROD) showFatal(String((e as PromiseRejectionEvent).reason)); });
